import React, { useEffect } from "react";
import { Container } from "@pixi/react";
import { BitmapText } from "@pixi/react";
import BasicTexture from "../../../Elements/Textures/BasicTexture";
import { useSelector, useDispatch } from "react-redux";
import { setFreeSpinsLeft } from "../../../State/Slices/freeSpinsSlice";

const FreeSpinCounter = ({ y, x, zIndex, symbolSize }) => {
  const dispatch = useDispatch();

  // Use `currentRound` instead of `round[roundIndex]`
  const { currentRound } = useSelector((state) => state.game);
  const { spinComplete, isSpinning } = useSelector((state) => state.spin);
  const { freeSpinsLeft } = useSelector((state) => state.freeSpins);

  useEffect(() => {
    if (!isSpinning && spinComplete) {
      dispatch(setFreeSpinsLeft(currentRound.freeSpins));
    }
  }, [currentRound, spinComplete, isSpinning, dispatch]);

  return (
    <Container y={y} x={x} zIndex={zIndex} name="FreeSpinCounter">
      {freeSpinsLeft > 0 && (
        <>
          <BasicTexture
            height={symbolSize / 2}
            width={symbolSize * 1.5}
            zIndex={zIndex}
            textureName="featureDisplayBackground"
          />
          <BitmapText
            text={freeSpinsLeft}
            anchor={0.5}
            style={{
              fontName: "jackpot-diamond",
              fontSize: symbolSize / 5,
              fill: "#ffffff",
              fontWeight: "bold",
              align: "center",
            }}
          />
          <BasicTexture
            height={symbolSize / 4}
            width={symbolSize * 1.5}
            y={symbolSize / 4}
            zIndex={zIndex}
            textureName="freeSpinsText"
          />
        </>
      )}
    </Container>
  );
};

export default FreeSpinCounter;
